// Keep editor formatting without allowing page positioning, external CSS
// resources, executable values, or arbitrary custom properties.
const allowedProperties = new Set([
  'color', 'background-color', 'font-family', 'font-size', 'font-weight', 'font-style',
  'text-align', 'text-decoration', 'text-indent', 'line-height', 'letter-spacing',
  'vertical-align', 'direction', 'width', 'height', 'max-width', 'max-height',
  'min-width', 'min-height', 'margin', 'margin-top', 'margin-right', 'margin-bottom',
  'margin-left', 'padding', 'padding-top', 'padding-right', 'padding-bottom',
  'padding-left', 'float', 'clear', 'border', 'border-width', 'border-style',
  'border-color', 'border-top', 'border-right', 'border-bottom', 'border-left',
  'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width',
  'border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style',
  'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color',
  'border-radius', 'border-collapse', 'border-spacing', 'table-layout', 'caption-side',
  'object-fit', 'object-position', 'aspect-ratio'
]);

export function sanitizeRichTextStyle(value = '') {
  const source = document.createElement('span').style;
  source.cssText = String(value || '');
  const result = document.createElement('span').style;

  for (let index = 0; index < source.length; index += 1) {
    const property = source[index];
    const cssValue = source.getPropertyValue(property);
    if (!allowedProperties.has(property) || /url\s*\(|expression\s*\(|var\s*\(|[<>\\]|@import/i.test(cssValue)) continue;
    // Do not retain !important: responsive content limits must still apply.
    result.setProperty(property, cssValue);
  }
  const display = source.getPropertyValue('display');
  if (/^(block|inline|inline-block|table|inline-table|table-cell|table-row)$/.test(display)) {
    result.setProperty('display', display);
  }
  return result.cssText;
}
